import api from 'services/api'
import {
  CREATE_SURVEY,
  UPDATE_SURVEY,
  GET_SURVEY_DETAIL,
  GET_SURVEY_LIST,
  DELETE_SURVEY,
  VIEW_SURVEY,
  GET_SURVEY_ANSWER_LIST,
  EXPORT_SURVEY_CSV,
  GET_SURVEY_CHARTS_DATA,
} from '../endpoints'

export const submitSurvey = async (body, id) =>
  await api.post(id ? UPDATE_SURVEY : CREATE_SURVEY, body)

export const getSurveyDetail = async (id) => await api.get(`${GET_SURVEY_DETAIL}?survey_id=${id}`)

export const getSurveysList = async (body) => await api.post(GET_SURVEY_LIST, body)

export const getSurveyAnswerList = async (body) => await api.post(GET_SURVEY_ANSWER_LIST, body)

export const deleteSurvey = async (id) => await api.delete(DELETE_SURVEY, {data: {survey_id: id}})

export const viewSurvey = async (id) => await api.get(`${VIEW_SURVEY}?survey_id=${id}`)

export const exportSurveyAnswersCSV = async (body) => {
  return await api.post(EXPORT_SURVEY_CSV, body, {
    responseType: 'blob',
    transformResponse: (data) => data, // Prevent default JSON parsing
  })
}

export const getSurveyChartsData = async (body) => await api.post(GET_SURVEY_CHARTS_DATA, body)
